module.exports = __webpack_public_path__ + "img/instagram.627ef096.svg";